import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
} from "react";
import axios from "axios";
import { Redirect, useHistory } from "react-router-dom";
import {
  FaCalendarAlt,
  FaCheckCircle,
  FaClipboardCheck,
  FaHome,
  FaSyncAlt,
  FaTimesCircle,
  FaUserClock,
  FaUsers,
} from "react-icons/fa";
import MyLoader from "../Spinner/MyLoader";
import SessionManager from "../Utils/SessionManager";
import myToast from "../Utils/MyToast";
import COLORS from "../resources/colors/COLORS";
import AttendancePieChart from "../ChildComponent/AttendancePieChart ";
import BackButton from "../ChildComponent/BackButton";
import SelectClass from "../ChildComponent/SelectClass";
import CalendarView from "../ChildComponent/CalendarView";
import boyImage from "../img/boy.jpg";
import "../css/Admin_css/admin-customize.css";
import "../css/Admin_css/payroll.css";

const API_BASE = () =>
  `${process.env.REACT_APP_SERVER_NAME}${process.env.REACT_APP_TARGET_DIR}`;

const HERO_GRADIENT = `linear-gradient(135deg, ${COLORS.primary_color_shade5} 0%, ${COLORS.primary_color_shade7} 55%, ${COLORS.primary_color_shade9} 100%)`;

const PAGE_FONT =
  'Inter, system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif';

//Created By Cursor
function applyDefaultMarks(list, presentAll) {
  return (Array.isArray(list) ? list : []).map((student) => ({
    ...student,
    attendence: student.OnLeave === "Yes" ? "L" : presentAll ? "P" : "A",
  }));
}

//Created By Cursor
function statusClass(mark) {
  if (mark === "P") return "tat-mark--p";
  if (mark === "A") return "tat-mark--a";
  if (mark === "L") return "tat-mark--l";
  return "";
}

//Created By Cursor
function formatIso(date) {
  const d = date.getDate();
  const m = date.getMonth() + 1;
  const y = date.getFullYear();
  const mm = m > 9 ? String(m) : `0${m}`;
  const dd = d > 9 ? String(d) : `0${d}`;
  return {
    iso: `${y}-${mm}-${dd}`,
    display: `${dd}-${mm}-${y}`,
    month: mm,
    year: y,
  };
}

//Created By Cursor
function parseHolidays(raw) {
  if (!raw) return [];
  if (Array.isArray(raw)) return raw;
  if (typeof raw === "string") {
    try {
      const parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }
  return [];
}

//Created By Cursor
function KpiChip({ tone, icon: Icon, label, value }) {
  return (
    <div className={`sm-kpi-chip sm-kpi-chip--${tone}`}>
      <span className="sm-kpi-chip__icon" aria-hidden>
        {Icon ? <Icon /> : null}
      </span>
      <div className="sm-kpi-chip__text">
        <span className="sm-kpi-chip__label">{label}</span>
        <span className="sm-kpi-chip__value">{value}</span>
      </div>
    </div>
  );
}

//Created By Cursor
export default function MonthAttendance() {
  const history = useHistory();
  const loggedIn = localStorage.getItem("token") != null;

  const [currentDate, setCurrentDate] = useState(() => {
    const d = new Date();
    d.setDate(1);
    return d;
  });
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [className, setClassName] = useState("");
  const [sectionName, setSectionName] = useState("");
  const [sessionId, setSessionId] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [classId, setClassId] = useState("");
  const [sectionId, setSectionId] = useState("");
  const [selectedClassPosition, setSelectedClassPosition] = useState(-1);

  const [attendanceData, setAttendanceData] = useState([]);
  const [events, setEvents] = useState([]);
  const [students, setStudents] = useState([]);
  const [presentAll, setPresentAll] = useState(true);

  const [dayStatus, setDayStatus] = useState("");
  const [report, setReport] = useState(null);
  const [studentInClass, setStudentInClass] = useState(0);
  const [studentByDate, setStudentByDate] = useState(0);
  const [studentDiff, setStudentDiff] = useState(0);
  const [holidayInfo, setHolidayInfo] = useState(null);

  const monthParts = useMemo(() => formatIso(currentDate), [currentDate]);
  const selectedParts = useMemo(
    () => formatIso(selectedDate),
    [selectedDate]
  );
  const classLabel = sectionName
    ? `${className}:${sectionName}`
    : className || "Select a class";

  const taken = /^taken$/i.test(dayStatus);
  //Created By Cursor — Sunday is takeable; holidays stay blocked for auto-skip only
  const dayBlocked = /^holiday$/i.test(dayStatus);
  const canTake =
    !!classId &&
    (!!dayStatus
      ? /^not\s*taken$/i.test(dayStatus) ||
        /^sunday$/i.test(dayStatus) ||
        dayBlocked
      : false);

  const liveCounts = useMemo(() => {
    if (taken && report) {
      return {
        total: Number(report.student || 0),
        present: Number(report.presentCount || 0),
        absent: Number(report.absentCount || 0),
        leave: Number(report.leaveCount || 0),
      };
    }
    return {
      total: students.length,
      present: students.filter((s) => s.attendence === "P").length,
      absent: students.filter((s) => s.attendence === "A").length,
      leave: students.filter((s) => s.attendence === "L").length,
    };
  }, [taken, report, students]);

  const callBackClassSelect = useCallback(
    (
      class_id,
      section_id,
      session_id,
      selected_position,
      class_name,
      section_name,
      _session_name,
      START_DATE,
      END_DATE
    ) => {
      setClassId(class_id);
      setClassName(class_name || "");
      setSectionName(section_name || "");
      setSectionId(section_id);
      setSessionId(session_id);
      setStartDate(START_DATE || "");
      setEndDate(END_DATE || "");
      setSelectedClassPosition(selected_position);
      setStudents([]);
      setDayStatus("");
      setReport(null);
      setHolidayInfo(null);
    },
    []
  );

  const loadMonthAttendance = useCallback(async () => {
    if (!classId || !sectionId || !monthParts.month || !monthParts.year) {
      return;
    }
    setLoading(true);
    setAttendanceData([]);
    setStudents([]);
    setDayStatus("");
    setReport(null);
    setHolidayInfo(null);
    try {
      const schoolCode = SessionManager.getSchoolCode();
      const params = {
        school_code: schoolCode,
        class_id: classId,
        section_id: sectionId,
        month: monthParts.month,
        year: String(monthParts.year),
        session_id: sessionId || "",
      };
      const url = `${API_BASE()}getParticularClassAttendence.php`;
      console.log("Full URL: ", `${url}?${new URLSearchParams(params)}`);

      const response = await axios.get(url, { params }).then((res) => res.data);
      if (response?.api_status === "OK") {
        const rows = Array.isArray(response.data) ? response.data : [];
        setAttendanceData(rows);
        setEvents(
          rows.map((item) => ({
            DATE: item.attendance_date || item.attendence_date,
            STATUS: item.status,
          }))
        );
      } else {
        setAttendanceData([]);
        setEvents([]);
        myToast.notify_warning(
          response?.api_remark || "Failed to load month attendance."
        );
      }
    } catch (error) {
      console.error(error);
      setAttendanceData([]);
      setEvents([]);
      myToast.notify_warning("Failed to load month attendance.");
    } finally {
      setLoading(false);
    }
  }, [
    classId,
    sectionId,
    sessionId,
    monthParts.month,
    monthParts.year,
  ]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (selectedClassPosition >= 0 && classId && sectionId) {
      loadMonthAttendance();
    }
  }, [
    selectedClassPosition,
    currentDate,
    classId,
    sectionId,
    loadMonthAttendance,
  ]);

  const loadStudents = useCallback(
    async (isoDate, presentAllFlag = presentAll) => {
      if (!classId || !sectionId || !isoDate) return;
      setLoading(true);
      try {
        const schoolCode = SessionManager.getSchoolCode();
        const params = {
          school_code: schoolCode,
          class_id: classId,
          section_id: sectionId,
          date: isoDate,
        };
        const url = `${API_BASE()}getStudentByDate.php`;
        console.log("Full URL: ", `${url}?${new URLSearchParams(params)}`);

        const response = await axios
          .get(url, { params })
          .then((res) => res.data);

        if (response?.api_status === "OK") {
          const rows = Array.isArray(response.data) ? response.data : [];
          setStudents(applyDefaultMarks(rows, presentAllFlag));
        } else {
          setStudents([]);
          myToast.notify_warning(
            response?.api_remark || "No students found for this date."
          );
        }
      } catch (error) {
        console.error(error);
        setStudents([]);
        myToast.notify_warning("Failed to load students.");
      } finally {
        setLoading(false);
      }
    },
    [classId, sectionId, presentAll]
  );

  const displayCalendarEvents = useCallback(
    (date) => {
      const parts = formatIso(date);
      setSelectedDate(date);
      setStudents([]);
      setReport(null);
      setHolidayInfo(null);

      const event = events.find((e) => e.DATE === parts.iso);
      const position = events.findIndex((e) => e.DATE === parts.iso);
      const status = String(event?.STATUS || "").trim();
      setDayStatus(status);

      if (/^taken$/i.test(status)) {
        if (position >= 0 && position < attendanceData.length) {
          const item = attendanceData[position];
          const inClass = Number(item.student || 0);
          const byDate = Number(item.student_by_date_count || 0);
          const present = Number(item.P || 0);
          const absent = Number(item.A || 0);
          const leave = Number(item.L || 0);
          setStudentInClass(inClass);
          setStudentByDate(byDate);
          setStudentDiff(inClass - byDate);
          setReport({
            student: byDate,
            presentCount: present,
            absentCount: absent,
            leaveCount: leave,
            presentPct:
              byDate === 0 ? 0 : Math.floor((present * 100) / byDate),
            absentPct:
              byDate === 0 ? 0 : Math.floor((absent * 100) / byDate),
            leavePct: byDate === 0 ? 0 : Math.floor((leave * 100) / byDate),
          });
        }
        return;
      }

      if (/^holiday$/i.test(status) && position >= 0) {
        const item = attendanceData[position];
        const holidays = parseHolidays(item?.holidays);
        if (holidays.length > 0) {
          const h = holidays[0];
          setHolidayInfo({
            occasion: h.holiday_Occasion || h.holiday_occasion || "Holiday",
            remark: h.holiday_remark || "",
            from: h.start_holiday_date || "",
            to: h.end_holiday_date || "",
            announced: h.date_added || "",
          });
        }
      }

      if (
        /^not\s*taken$/i.test(status) ||
        /^sunday$/i.test(status) ||
        /^holiday$/i.test(status)
      ) {
        loadStudents(parts.iso, presentAll);
      }
    },
    [events, attendanceData, loadStudents, presentAll]
  );

  useEffect(() => {
    if (events.length > 0) {
      displayCalendarEvents(selectedDate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [events]);

  const handlePrevMonth = () => {
    const prev = new Date(currentDate);
    prev.setMonth(prev.getMonth() - 1);
    prev.setDate(1);
    setCurrentDate(prev);
    setSelectedDate(prev);
  };

  const handleNextMonth = () => {
    const next = new Date(currentDate);
    next.setMonth(next.getMonth() + 1);
    next.setDate(1);
    setCurrentDate(next);
    setSelectedDate(next);
  };

  const onPresentAllChange = (checked) => {
    setPresentAll(checked);
    setStudents((prev) => applyDefaultMarks(prev, checked));
  };

  const isOnLeave = (student) =>
    String(student?.OnLeave || "").toLowerCase() === "yes";

  const toggleStatus = (enrollmentNo) => {
    setStudents((prev) =>
      prev.map((student) => {
        if (student.student_enrollment_no !== enrollmentNo) return student;
        if (isOnLeave(student)) return student;
        const next =
          student.attendence === "P"
            ? "A"
            : student.attendence === "A"
            ? "L"
            : "P";
        return { ...student, attendence: next };
      })
    );
  };

  const setMark = (enrollmentNo, mark) => {
    setStudents((prev) =>
      prev.map((s) => {
        if (s.student_enrollment_no !== enrollmentNo) return s;
        if (isOnLeave(s)) return s;
        return { ...s, attendence: mark };
      })
    );
  };

  const submitAttendance = async () => {
    if (!students.length) {
      myToast.notify_warning("No students to submit.");
      return;
    }
    const staff = SessionManager.getStaffDetails();
    const staffId = staff?.staff_id;
    if (!staffId) {
      myToast.notify_warning("Missing staff details.");
      return;
    }

    setSaving(true);
    try {
      const schoolCode = SessionManager.getSchoolCode();
      const body = new URLSearchParams();
      body.append("class_id", classId);
      body.append("section_id", sectionId);
      body.append("date", selectedParts.iso);
      body.append("attendence", JSON.stringify(students));
      body.append("staff_id", staffId);
      body.append("school_code", schoolCode);

      const url = `${API_BASE()}addStudentAttendence.php`;
      console.log("Full URL: ", url);

      const response = await axios.post(url, body).then((res) => res.data);
      if (response?.api_status === "OK") {
        myToast.notify_success("Attendance submitted.");
        await loadMonthAttendance();
      } else {
        myToast.notify_warning(response?.api_remark || "Submit failed.");
      }
    } catch (error) {
      console.error(error);
      myToast.notify_warning("Failed to submit attendance.");
    } finally {
      setSaving(false);
    }
  };

  const busy = loading || saving;
  const monthLabel = currentDate.toLocaleString("default", {
    month: "long",
    year: "numeric",
  });

  if (!loggedIn) return <Redirect to="/Login" />;

  return (
    <div
      className="content payroll-page sm-page mat-page tat-page"
      style={{ fontFamily: PAGE_FONT, background: "#ffffff" }}
    >
      <div
        className="content-header d-flex justify-content-between align-items-center"
        style={{ background: COLORS.primary_color_shade5 }}
      >
        <div className="leftside-content-header d-flex align-items-center gap-2">
          <button
            type="button"
            className="qb-home-btn"
            aria-label="Home"
            onClick={() => history.push("/AdminMain")}
          >
            <FaHome />
          </button>
          <ul className="breadcrumbs mb-0">
            <li>
              <span style={{ color: COLORS.white }}>Attendance</span>
            </li>
            <li>
              <span style={{ color: COLORS.white }}>Month</span>
            </li>
          </ul>
        </div>
        <div className="rightside-content-header">
          <BackButton />
        </div>
      </div>

      <div className="bg_page_white_rounded box_shadow animated fadeInUp sm-shell mat-shell">
        <header className="sm-hero" style={{ "--sm-hero-bg": HERO_GRADIENT }}>
          <div className="sm-hero__brand">
            <div className="sm-hero__icon" aria-hidden>
              <FaCalendarAlt />
            </div>
            <div className="min-w-0">
              <h1 className="sm-hero__title">Month Attendance</h1>
              <p className="sm-hero__sub">
                {classLabel} · {monthLabel}
                {dayStatus ? ` · ${dayStatus}` : ""}
              </p>
            </div>
          </div>
          <div className="sm-hero__tools">
            <button
              type="button"
              className={`pp-icon-btn${loading ? " spinning" : ""}`}
              onClick={loadMonthAttendance}
              disabled={busy || !classId}
              aria-label="Refresh"
              title="Refresh"
            >
              <FaSyncAlt aria-hidden />
            </button>
          </div>
        </header>

        <div className="mat-body">
          <div className="mat-filters">
            <SelectClass
              action={callBackClassSelect}
              selected_position={selectedClassPosition}
            />
          </div>

          {!classId ? (
            <div className="mat-empty">Select a class to view the calendar.</div>
          ) : (
            <>
              <div className="mat-calendar-wrap">
                <CalendarView
                  events={events}
                  disableFutureDates={true}
                  selectedDate={selectedDate}
                  onDayPress={(date) => displayCalendarEvents(date)}
                  onDayLongPress={() => {}}
                  onPrevPress={handlePrevMonth}
                  onNextPress={handleNextMonth}
                  start_date={startDate}
                  end_date={endDate}
                />
              </div>

              <div className="mat-meta">
                <div className="mat-meta__item">
                  <span>Class</span>
                  <strong>{classLabel}</strong>
                </div>
                <div className="mat-meta__item">
                  <span>Selected date</span>
                  <strong>{selectedParts.display}</strong>
                </div>
                {canTake ? (
                  <label className="mat-present-all">
                    <span>Mark all present</span>
                    <input
                      type="checkbox"
                      checked={presentAll}
                      onChange={(e) => onPresentAllChange(e.target.checked)}
                      disabled={busy || !students.length}
                    />
                    <span className="mat-switch" aria-hidden />
                  </label>
                ) : null}
              </div>

              {/^holiday$/i.test(dayStatus) ? (
                <div className="mat-banner mat-banner--holiday">
                  <strong>{holidayInfo?.occasion || "Holiday"}</strong>
                  {holidayInfo?.remark ? <span>{holidayInfo.remark}</span> : null}
                  {holidayInfo?.from || holidayInfo?.to ? (
                    <span>
                      {holidayInfo.from ? `From ${holidayInfo.from}` : ""}
                      {holidayInfo.to ? ` · To ${holidayInfo.to}` : ""}
                    </span>
                  ) : null}
                </div>
              ) : null}

              {(canTake || (!taken && students.length > 0)) && (
                <div className="sm-kpi-row mat-kpis" aria-label="Attendance totals">
                  <KpiChip
                    tone="sky"
                    icon={FaUserClock}
                    label="Total"
                    value={liveCounts.total}
                  />
                  <KpiChip
                    tone="mint"
                    icon={FaCheckCircle}
                    label="Present"
                    value={liveCounts.present}
                  />
                  <KpiChip
                    tone="sand"
                    icon={FaTimesCircle}
                    label="Absent"
                    value={liveCounts.absent}
                  />
                  <KpiChip
                    tone="blue"
                    icon={FaCalendarAlt}
                    label="Leave"
                    value={liveCounts.leave}
                  />
                </div>
              )}

              {loading && !students.length && !taken ? (
                <div className="mat-loading">
                  <MyLoader />
                </div>
              ) : null}

              {taken ? (
                <section className="mat-report-card">
                  <div className="mat-report-card__head">
                    <div className="mat-report-card__title">
                      <span className="mat-report-card__icon" aria-hidden>
                        <FaClipboardCheck />
                      </span>
                      <div>
                        <h2>Attendance report</h2>
                        <p>
                          {classLabel} · {selectedParts.display}
                        </p>
                      </div>
                    </div>
                    <span className="mat-report-badge">Taken</span>
                  </div>

                  <div className="mat-report-body">
                    <div className="mat-report-chart">
                      <AttendancePieChart
                        Present={liveCounts.present}
                        Absent={liveCounts.absent}
                        Leave={liveCounts.leave}
                        size={180}
                        showLegend
                      />                    </div>

                    <div className="mat-report-breakdown">
                      <div className="mat-report-bar is-p">
                        <div className="mat-report-bar__meta">
                          <span>
                            <FaCheckCircle aria-hidden /> Present
                          </span>
                          <strong>
                            {liveCounts.present}
                            <small>
                              {report ? `${report.presentPct}%` : "0%"}
                            </small>
                          </strong>
                        </div>
                        <div className="mat-report-bar__track" aria-hidden>
                          <i
                            style={{
                              width: `${Math.min(
                                100,
                                Number(report?.presentPct || 0)
                              )}%`,
                            }}
                          />
                        </div>
                      </div>

                      <div className="mat-report-bar is-a">
                        <div className="mat-report-bar__meta">
                          <span>
                            <FaTimesCircle aria-hidden /> Absent
                          </span>
                          <strong>
                            {liveCounts.absent}
                            <small>
                              {report ? `${report.absentPct}%` : "0%"}
                            </small>
                          </strong>
                        </div>
                        <div className="mat-report-bar__track" aria-hidden>
                          <i
                            style={{
                              width: `${Math.min(
                                100,
                                Number(report?.absentPct || 0)
                              )}%`,
                            }}
                          />
                        </div>
                      </div>

                      <div className="mat-report-bar is-l">
                        <div className="mat-report-bar__meta">
                          <span>
                            <FaCalendarAlt aria-hidden /> Leave
                          </span>
                          <strong>
                            {liveCounts.leave}
                            <small>
                              {report ? `${report.leavePct}%` : "0%"}
                            </small>
                          </strong>
                        </div>
                        <div className="mat-report-bar__track" aria-hidden>
                          <i
                            style={{
                              width: `${Math.min(
                                100,
                                Number(report?.leavePct || 0)
                              )}%`,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mat-report-foot">
                    <div className="mat-report-chip">
                      <span className="mat-report-chip__icon" aria-hidden>
                        <FaUsers />
                      </span>
                      <div>
                        <span>Students in class</span>
                        <strong>{studentInClass}</strong>
                      </div>
                    </div>
                    <div className="mat-report-chip">
                      <span className="mat-report-chip__icon is-sky" aria-hidden>
                        <FaUserClock />
                      </span>
                      <div>
                        <span>Recorded on date</span>
                        <strong>{studentByDate}</strong>
                      </div>
                    </div>
                    <div
                      className={`mat-report-chip${
                        studentDiff !== 0 ? " is-warn" : ""
                      }`}
                    >
                      <span
                        className={`mat-report-chip__icon${
                          studentDiff !== 0 ? " is-warn" : " is-mint"
                        }`}
                        aria-hidden
                      >
                        <FaClipboardCheck />
                      </span>
                      <div>
                        <span>Difference</span>
                        <strong>{studentDiff}</strong>
                      </div>
                    </div>
                  </div>
                </section>
              ) : null}

              {canTake ? (
                <>
                  {students.length === 0 ? (
                    <div className="mat-empty">
                      {loading
                        ? <MyLoader />
                        : "No students found for this date."}
                    </div>
                  ) : (
                    <section className="tat-list-card mat-list-card">
                      <div className="tat-list-card__head">
                        <h2 className="tat-list-card__title">Students</h2>
                        <span className="tat-list-card__count">
                          {students.length}
                        </span>
                      </div>
                      <div className="tat-student-list" role="list">
                        {students.map((student, index) => {
                          const mark = student.attendence || "P";
                          const locked = isOnLeave(student);
                          const name = student.stu_name || "—";
                          const initials = String(name)
                            .trim()
                            .split(/\s+/)
                            .slice(0, 2)
                            .map((p) => p[0] || "")
                            .join("")
                            .toUpperCase();
                          return (
                            <div
                              key={
                                student.student_enrollment_no ||
                                student.student_roll_no ||
                                `${name}-${index}`
                              }
                              role="listitem"
                              className={`tat-student ${statusClass(mark)}${
                                locked ? " tat-student--locked" : ""
                              }`}
                            >
                              <span className="tat-student__roll">
                                {student.student_roll_no || index + 1}
                              </span>
                              <button
                                type="button"
                                className="tat-student__main"
                                onClick={() =>
                                  toggleStatus(student.student_enrollment_no)
                                }
                                disabled={busy || locked}
                                title={
                                  locked
                                    ? "Leave found — marked L"
                                    : "Tap to toggle Present / Absent / Leave"
                                }
                              >
                                <span className="tat-student__avatar-wrap">
                                  <img
                                    className="tat-student__avatar"
                                    src={student.student_img_path || boyImage}
                                    alt=""
                                    onError={(e) => {
                                      e.currentTarget.style.display = "none";
                                      const fallback =
                                        e.currentTarget.nextElementSibling;
                                      if (fallback)
                                        fallback.style.display = "inline-flex";
                                    }}
                                  />
                                  <span
                                    className="tat-student__initials"
                                    style={{ display: "none" }}
                                    aria-hidden
                                  >
                                    {initials || "?"}
                                  </span>
                                </span>
                                <span className="tat-student__body">
                                  <strong>{name}</strong>
                                  <small>
                                    S/O {student.father_name || "—"}
                                    {locked ? " · On leave" : ""}
                                  </small>
                                </span>
                              </button>
                              <div className="tat-student__actions">
                                {locked ? (
                                  <span className="tat-mark-pill tat-mark-pill--l is-active">
                                    L
                                  </span>
                                ) : (
                                  <>
                                    <button
                                      type="button"
                                      className={`tat-mark-pill tat-mark-pill--p${
                                        mark === "P" ? " is-active" : ""
                                      }`}
                                      disabled={busy}
                                      onClick={() =>
                                        setMark(
                                          student.student_enrollment_no,
                                          "P"
                                        )
                                      }
                                    >
                                      P
                                    </button>
                                    <button
                                      type="button"
                                      className={`tat-mark-pill tat-mark-pill--a${
                                        mark === "A" ? " is-active" : ""
                                      }`}
                                      disabled={busy}
                                      onClick={() =>
                                        setMark(
                                          student.student_enrollment_no,
                                          "A"
                                        )
                                      }
                                    >
                                      A
                                    </button>
                                    <button
                                      type="button"
                                      className={`tat-mark-pill tat-mark-pill--l${
                                        mark === "L" ? " is-active" : ""
                                      }`}
                                      disabled={busy}
                                      onClick={() =>
                                        setMark(
                                          student.student_enrollment_no,
                                          "L"
                                        )
                                      }
                                    >
                                      L
                                    </button>
                                  </>
                                )}
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </section>
                  )}

                  <div className="tat-footer mat-footer">
                    <div className="tat-footer__counts">
                      <span className="is-p">Present {liveCounts.present}</span>
                      <span className="is-a">Absent {liveCounts.absent}</span>
                      <span className="is-l">Leave {liveCounts.leave}</span>
                    </div>
                    <button
                      type="button"
                      className="tat-btn tat-btn--primary"
                      onClick={submitAttendance}
                      disabled={busy || !students.length}
                    >
                      {saving ? "Submitting…" : "Submit Attendance"}
                    </button>
                  </div>
                </>
              ) : null}
            </>
          )}
        </div>
      </div>
    </div>
  );
}
